var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinBackFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 91,
    viewBox: "0 0 84 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3917_52668)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "url(#paint0_linear_3917_52668)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3917_52668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7755 18.8901L51.4194 19.2506L51.9602 19.6885L52.398 20.152L52.7586 20.6156L53.0419 21.0792L53.2479 21.4912L53.4282 21.9033L53.557 22.2896L53.66 22.6502L53.7373 23.0107L53.7888 23.3713L53.8403 23.7061L53.8918 24.0409V24.3499L53.9175 24.6847V25.0196V25.3286V25.6634V25.9724V26.5905V26.9254V27.2344V27.5692V27.904V28.2131V28.5479V28.8827V29.1917V29.5265V29.8613V30.1961L45.4444 30.4537V30.0673V29.681V29.2947V28.9084V28.2131V27.8525V27.5177V27.1829V26.8738V26.5905V26.3073V25.9982V25.7407V25.5089V25.2771V25.0711V24.8908L45.4187 24.7363V24.6075V24.5045V24.4272L45.4702 24.5302L45.5217 24.659L45.6505 24.865L45.8308 25.0968L46.0883 25.3801L46.4231 25.6634L46.8094 25.8952L50.9043 18.9158L50.7755 18.8901ZM17.63 43.717V38.9783L18.2997 38.1799L19.0465 37.4073L19.8449 36.6089L20.6948 35.8105L21.6219 35.0121L22.6006 34.188L23.605 33.3639L24.6609 32.5397L25.7683 31.7156L26.8758 30.8915L28.0347 30.0416L29.2194 29.1917L30.4041 28.3676L31.6145 27.5692L32.7992 26.7708L33.9839 25.9724L35.1686 25.2256L36.3275 24.4787L37.4607 23.7576L38.5681 23.088L39.6498 22.4441L40.6799 21.8518L41.6586 21.2852L42.56 20.7701L43.4099 20.2808L44.2082 19.8687L44.9551 19.4824L45.6505 19.1476L46.3201 18.8643L47.0412 18.6068L48.0971 18.375L50.8528 18.8386L46.7579 25.8179L49.2045 26.2557L49.7196 26.1527H49.6681L49.3591 26.3073L48.8955 26.5133L48.3289 26.7966L47.6593 27.1571L46.8867 27.5692L46.0368 28.0585L45.1354 28.5736L44.1825 29.1402L43.1781 29.7583L42.1479 30.4022L41.0663 31.0718L39.9588 31.7671L38.8514 32.4882L37.7182 33.2093L36.5593 33.982L35.4261 34.7546L34.2929 35.5272L33.1855 36.2998L32.1038 37.0725L31.0479 37.8451L30.0435 38.6177L29.0906 39.3646L28.1892 40.0857L27.3651 40.781L26.6182 41.4506L25.9229 42.0687L25.3305 42.6353L24.8669 43.1504L24.5064 43.5625V38.8237L17.6816 43.5625L17.63 43.717ZM17.63 43.717L15.75 41.3476L17.63 38.9783V43.717ZM50.7498 63.8052L47.9941 64.2688L46.9382 64.037L46.2171 63.7794L45.5475 63.4961L44.8521 63.1613L44.1052 62.775L43.3069 62.3629L42.457 61.8736L41.5556 61.3585L40.5769 60.792L39.5468 60.1996L38.4651 59.5558L37.3577 58.8862L36.2245 58.1908L35.0656 57.4439L33.8809 56.6971L32.6962 55.8987L31.4857 55.1003L30.2753 54.3019L29.0906 53.4778L27.9059 52.6279L26.747 51.778L25.6396 50.9539L24.5321 50.1298L23.4762 49.3056L22.4718 48.4815L21.4932 47.6574L20.566 46.859L19.7161 46.0606L18.9177 45.2622L18.1709 44.4896L17.5013 43.6912L24.3261 38.9525L24.6867 39.3646L25.1502 39.8796L25.7426 40.4462L26.4379 41.0643L27.1848 41.7339L28.0089 42.4293L28.9103 43.1504L29.8632 43.8973L30.8676 44.6699L31.9236 45.4425L33.0052 46.2151L34.1127 46.9878L35.2458 47.7604L36.379 48.533L37.5122 49.3056L38.6454 50.0268L39.7528 50.7479L40.8602 51.4432L41.9419 52.1128L42.9721 52.7567L43.9765 53.3748L44.9294 53.9414L45.8308 54.4565L46.6806 54.9458L47.4533 55.3578L48.1229 55.7184L48.6895 56.0017L49.153 56.2077L49.4621 56.3365H49.5136L48.9985 56.2592L46.5519 56.6971L50.621 63.6764L50.7498 63.8052ZM49.6424 56.3365L53.8918 52.4991V52.834V53.1687V53.5036V53.8126V54.4822V54.817V55.1261V55.4609V55.7699V56.1047V56.4138V56.7228V57.0319V57.3667V57.6757V58.0105V58.3453L53.866 58.6544L53.8145 58.9892L53.763 59.324L53.7115 59.6845L53.6342 60.0451L53.5312 60.4056L53.4025 60.792L53.2222 61.204L53.0161 61.6418L52.7328 62.1054L52.3723 62.569L51.9345 63.0583L51.3936 63.4961L50.7498 63.8824L46.6806 56.9031L46.2943 57.1349L45.9595 57.3924L45.702 57.6757L45.5217 57.9075L45.3929 58.1135L45.3414 58.2423L45.2899 58.3453L45.3157 58.2681V58.165V58.0363V57.8817L45.3414 57.7015V57.4954V57.2636V57.0319V56.7486V56.182V55.8987V55.5896V55.2548V54.8943V54.5595V54.1989V53.8641V53.4778V53.0915V52.7052V52.3189L49.5909 48.4815V56.4138L49.6424 56.3365ZM45.3929 52.2416L45.5217 48.4042H49.6166L45.3672 52.2416H45.3929ZM62.3134 52.3704L58.0639 56.3365H49.6424V48.4042H58.0639L62.3134 52.3704ZM62.3134 52.3704V56.3365H58.0639L62.3134 52.3704ZM58.0639 26.3588L62.3134 30.3506V52.3961H53.8403V30.3506L58.0897 26.3588H58.0639ZM58.0639 26.3588H62.3134V30.3506L58.0639 26.3588ZM45.3929 30.4794L49.6424 26.3588H58.0639V34.3425H49.6424L45.3929 30.4794ZM49.6424 34.3425H45.5475L45.4187 30.4794L49.6681 34.3425H49.6424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6407 30.3249C49.512 26.4618 50.0271 23.0365 48.7393 22.3669C47.6834 21.8261 26.0242 35.0637 21.0537 41.3477C26.0242 47.6317 47.6834 60.8693 48.7393 60.3284C50.0528 59.6588 49.512 56.2593 49.6407 52.3704H58.0623V30.3249H49.6407Z",
    fill: "#0C4629"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3917_52668",
    x: 0,
    y: 0,
    width: 84,
    height: 90.3969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.39692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.109804 0 0 0 0 0.0745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3917_52668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3917_52668",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3917_52668",
    x: 15.75,
    y: 18.375,
    width: 46.5635,
    height: 52.4485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.55473
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0194444 0 0 0 0 0.233333 0 0 0 0 0.136738 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3917_52668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3917_52668",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3917_52668",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22824B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B4327"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinBackFree);
export default __webpack_public_path__ + "static/media/spin-back-free.2dfc8034308497715f1920bebd37fa81.svg";
export { ForwardRef as ReactComponent };